import axios from 'axios';
import router from '@/router';
import { getAccessToken } from './auth';

const URL = `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api`;

const client = axios.create({
    baseURL: URL,
    json: true
})

export default {
    async execute(method, resource, data) {
        let accessToken = getAccessToken();
        return client({
            method,
            url: resource,
            data,
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        }).then(req => {
            return req.data;
        }).catch(error => {
            if (error.response) {
                if (error.response.status === 404) {
                    router.push('/404');
                }
                return error.response.data;
            } else {
                return 'Impossible d\'atteindre le serveur.';
            }
        });
    },
    getNews(){
        return this.execute('get', '/daily');
    },
    getInfo() {
        return this.execute('get', '/info');
    },
    getSites() {
        return this.execute('get', '/sites');
    },
    getFonctions() {
        return this.execute('post', '/fonctions');
    },
    getEmployes() {
        return this.execute('get', '/employes');
    },
    getEmployeById(id) {
        return this.execute('get', `/employes/${id}`);
    },
    getPeriodes() {
        return this.execute('get', `/settings/periodes`)
    },
    getHorairesPerso() {
        return this.execute('get', '/horaires/perso');
    },
    getHorairesGeneral() {
        return this.execute('get', `/horaires/general/staff`);
    },
    getMesDemandes() {
        return this.execute('get', '/remplacements/me');
    },
    getRemplacementsDemandes() {
        return this.execute('get', '/remplacements/demandes');
    },
    createDemandeRemplacement(horaire, employe_id) {
        return this.execute('post', `/remplacements/demande/${horaire}`, {employe_id});
    },
    proposerRemplacement(id) {
        return this.execute('post', `/remplacements/proposition/${id}`);
    },
    annulerRemplacement(id){
        return this.execute('delete', `/remplacements/demande/${id}`);
    },
    getHeures(begindate, enddate) {
        return this.execute('get', `/heures/perso/${begindate}/${enddate}`);
    },
    getVacances(){
        return this.execute('get', `/vacances/@me`);
    },
    login(username, password) {
        return this.execute('post', '/login', { username, password });
    },
    getUser() {
        return this.execute('get', `/employes/@me`);
    },
    getQSPs(){
        return this.execute('get', `/qsp/propositions`)
    },
    proposerQSP(id){
        return this.execute('patch',`/qsp/propositions/${id}`);
    },
    getParticularites(){
        return this.execute('get', `/particularites`);
    },
    pdf(url, params, filename) {
        axios(`${URL}/pdf/${url}`, {
            method: "GET",
            responseType: "blob",
            headers: {
                Authorization: `Bearer ${getAccessToken()}`
            },
            params
        })
            .then(response => {
                if (response.data) {
                    const blob = new Blob([response.data], {
                        type: "application/pdf"
                    });
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    let url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = `${filename}.pdf`;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
            })
            .catch(error => {
                console.log(error.response);
                if (error.response.status === 403) {
                    router.push('/login');
                }
            });
    },
    ical(url, params, filename) {
        axios(`${URL}/ical/${url}`, {
            method: "GET",
            responseType: "blob",
            headers: {
                Authorization: `Bearer ${getAccessToken()}`
            },
            params
        })
            .then(response => {
                if (response.data) {
                    const blob = new Blob([response.data], {
                        type: "octet/stream"
                    });
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    let url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = `${filename}.ics`;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
            })
            .catch(error => {
                console.log(error.response);
                if (error.response.status === 403) {
                    router.push('/login');
                }
            });
    }
}